<app-dialog
  [title]="'Add Vendor Item to PO'"
  [actions]="[
    { text: 'Cancel', buttonStyle: 'underline' },
    { text: 'Confirm', isDisabled: !selectedItems.length,spin: spin }
  ]"
  (action)="action($event)"
  (close)="action($event)"
>
  <div class="add-sku">
    <div class="add-sku_form" [formGroup]="form">
      <div class="input-container input-container--fullWidth">
        <label for="" class="input-container_label">Items</label>
        <input
          type="text"
          class="input-container_input"
          formControlName="autocomplete"
          [matAutocomplete]="auto"
          (click)="setScroll()"
        />
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayWith">
          <mat-option
            *ngFor="let option of filteredOptions$"
            [value]="option"
            class="mat-option-override"
          >
            <app-item-typeahead
              [name]="option.title"
              [sku]="option.sku"
              [id]="option.name"
              [image]="option.imageUrl"
            ></app-item-typeahead>
          </mat-option>
        </mat-autocomplete>
      </div>

      <div class="input-container input-container--qty">
        <label for="" class="input-container_label">Quantity</label>
      <div class="input-container_wrapper">
        <div class="input-container_icon input-container_icon--iconRight px-2">
          <mat-select panelClass="price-select" formControlName="type" >
            <mat-option value="quantity"><span>Qty</span></mat-option>
            <mat-option value="cases"><span>Cases</span></mat-option> 
          </mat-select>
        </div>
        <input
          type="number"
          class="input-container_input"
          [min]="0"
          formControlName="qty"
        />
        <span
          class="danger_color2 error-msg mt-2"
          *ngIf="
            (form.get('qty').touched || form.get('qty').dirty) &&
            form.get('qty').errors
          "
        >
        </span>
        </div>
      </div>

      <div class="add-sku_button">
        <app-button
          (click)="insertInList()"
          [isDisabled]="form.invalid"
        >
          Add Item
        </app-button>
      </div>
    </div>
    <div class="add-sku_result"><span class="me-1" *ngIf="filteredOptions$?.length == 0 && form.get('autocomplete').valid">No Vendor item found</span><a draggable="false" href="javascript:void(0)" class="primary_color" [ngClass]="{'disabled' : !vendorId}" (click)="createItem()">Create New Vendor Item?</a></div>
    <mat-dialog-content *ngIf="selectedItems.length">
      <div class="add-sku_list">
        <div class="add-sku_list-title">Selected Items</div>
        <app-shipment-sku
                [vendorItem]="true"
                [box]="true"
                [sku]="item"
                [skuRemove]="true"
                (removeSkuEvent)="removeItem(item)"
                *ngFor="let item of selectedItems"
        ></app-shipment-sku>
      </div>
    </mat-dialog-content>
  </div>
</app-dialog>
